<template>
  <div class="home">
    <monitor-pedidos :modo="modo" />
  </div>
</template>

<script>
import MonitorPedidos from '@/components/monitorUsuario/Monitor.vue'

export default {
  name: 'Home',
  components: {
    MonitorPedidos
  },
  props: {
    modo: {
      type: String,
      default: 'picking'
    }
  }
}
</script>
